import { createSelector } from 'reselect';

const data = (state) => state.employmentStatusesPopupData;

export const selectEmploymentStatusesData = () => createSelector([data], (state) => state.statuses);
